import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import Login from './pages/Login';
import CameraHub from './pages/CameraHub';
import ZoneEditor from './pages/ZoneEditor';
import Projects from './pages/Projects';
import Zones from './pages/Zones';
import Admin from './pages/Admin';
import UserManagement from './pages/UserManagement';
import Layout from './components/Layout';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <ProjectProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<CameraHub />} />
              <Route path="cameras" element={<CameraHub />} />
              <Route path="projects" element={<Projects />} />
              <Route path="zones" element={<Zones />} />
              <Route path="zones/editor" element={<ZoneEditor />} />
              <Route path="admin" element={<Admin />} />
              <Route path="admin/users" element={<UserManagement />} />
            </Route>
          </Routes>
        </Router>
      </ProjectProvider>
    </AuthProvider>
  );
}

export default App;
